var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskassessment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-708 -471)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(708 471)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_62bad693062729431bc228b362cb8645",
    "data-name": "62bad693062729431bc228b362cb8645",
    transform: "translate(716 479.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M0,194.626v15.233H50.939V194.626C34.712,186.3,17.7,186.661,0,194.626Z",
    transform: "translate(0 -169.157)",
    fill: "#495053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M7.46,72.64c7.543.831,12.408,6.347,15.306,15.306.78,2.021.547,3.151-1.119,2.7H0A25.39,25.39,0,0,1,7.46,72.64Z",
    transform: "translate(0 -65.18)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M287.656,90.65H266.009c-2.7-.15-2.714-1.244-1.119-2.7,2.661-7.032,8.042-11.913,15.306-15.306A25.39,25.39,0,0,1,287.656,90.65Z",
    transform: "translate(-236.717 -65.18)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M241.716,7.46,226.409,22.767c-.939.453-1.2-.016-1.2-.812-5.62-4.931-5.268-10.977-1.5-17.693-1.191-1.49-1.321-2.918,0-4.261A25.39,25.39,0,0,1,241.716,7.46Z",
    transform: "translate(-198.236)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M90.65,0A25.39,25.39,0,0,0,72.64,7.46L87.946,22.767c.837.256,1.386.149,1.2-.812l1.5-17.693Z",
    transform: "translate(-65.18)",
    fill: "#3360e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M234.864,41.49a100.843,100.843,0,0,0-1.5,17.693h3.007A100.842,100.842,0,0,0,234.864,41.49Z",
    transform: "translate(-209.394 -37.229)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M217.306,211.9a3.812,3.812,0,1,1-1.2-.812A3.809,3.809,0,0,1,217.306,211.9Z",
    transform: "translate(-189.133 -189.133)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M277.758,214.609c0,.088,0,.177-.009.263h-2.31a3.809,3.809,0,0,0-1.119-2.7l1.089-1.089.031.013a3.825,3.825,0,0,1,2.319,3.515Z",
    transform: "translate(-246.147 -189.402)",
    fill: "#53b79a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M29.292,248H31.6a3.823,3.823,0,0,1-4.562,3.487A3.823,3.823,0,0,0,29.292,248Zm21.647,0v15.233H0c25.836,0,35.514-7.051,38.046-15.233Z",
    transform: "translate(0 -222.53)",
    fill: "#383d40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M380.06,90.65H367.167a21.212,21.212,0,0,0-.377-12.2l5.81-5.81A25.39,25.39,0,0,1,380.06,90.65Z",
    transform: "translate(-329.12 -65.18)",
    fill: "#3360e9",
    opacity: 0.534
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M259.19,19.238q.344,4.159.353,8.309c0,.16,0,.321,0,.482a3.829,3.829,0,0,1,1.2.812l1.089-1.089.031-.031a100.841,100.841,0,0,0-1.5-17.649C259.816,13.127,259.432,16.184,259.19,19.238ZM263.975,6.77a44.368,44.368,0,0,1,6.266,12.575l5.81-5.81A25.426,25.426,0,0,0,263.975,6.77Z",
    transform: "translate(-232.571 -6.075)",
    fill: "#247a3d",
    opacity: 0.553
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskassessment);
export default __webpack_public_path__ + "static/media/riskassessment.415b5260d85b751f6979e4d6ec4fc452.svg";
export { ForwardRef as ReactComponent };